export const DEFAULT_PAYMENT_DECLINE_CODE = 'payment_declined';

export type PaymentErrorSource = Record<string, unknown> | null | undefined;

export const asPaymentErrorSource = (value: unknown): PaymentErrorSource =>
  value && typeof value === 'object' ? (value as Record<string, unknown>) : undefined;

export const pickPaymentDeclineCode = (...sources: PaymentErrorSource[]): string => {
  for (const source of sources) {
    const code = source?.decline_code ?? source?.processor_response;
    if (typeof code === 'string' && code.trim()) return code.trim();
  }

  return DEFAULT_PAYMENT_DECLINE_CODE;
};

export const pickPaymentErrorMessage = (...sources: PaymentErrorSource[]): string => {
  for (const source of sources) {
    const message = source?.message ?? source?.messages;
    if (typeof message === 'string' && message.trim()) return message.trim();
  }

  return '';
};
